@if (fileContainer$ | async; as fileContainer) {
	<stages-files-files
		[layout]="layout"
		[showStartOptions]="showStartOptions"
		[translateNone]="translateNone"
		[fileSource]="(fileSource$ | async)!"
		[fileContainer]="fileContainer"
	/>
}
